import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import polyfillCSS from 'lib/polyfills/CSS.js';
// import './error-tracking.js';

polyfillCSS(window);

window.InteractiveExtension = window.InteractiveExtension || {};
